import { alta } from '../../api/alta'
import { leerEspera, olvidarEspera } from './estado'

/**
 * «Continuar» desde la pantalla de progreso, con lo que ya se subió. Si en esta pestaña hay un
 * alta en espera de **esa** web (se salió del asistente con un documento sin leer, estado.ts),
 * sus imágenes van con ella: continuar con `{}` montaría la web sin el logotipo ni las fotos que
 * ya están en Medios. Si no hay nada guardado, sigue sin imágenes, como siempre.
 */
export const continuarConLoSubido = async (espacio: number, sitio: number, opciones: { sinIA?: boolean } = {}) => {
  const espera = leerEspera(espacio)
  const suya = espera !== null && espera.sitio === sitio
  const resultado = await alta.continuar(sitio, suya ? espera.medios : {}, opciones)
  if (suya) olvidarEspera(espacio)
  return resultado
}
